let isLocal = location.origin.includes("l.ezoic.com:13001");

let LIVECHAT_BASE_URL = 'livechat.ezoic.com';
if (isLocal) {
    LIVECHAT_BASE_URL = 'llivechat.ezoic.com:8889';
}

class LiveChat {
    constructor(params) {

        this.args = {
            lhc_var: {
                nick: params.nick ? params.nick : '', 
                email: params.email ? params.email : '', 
                param1: params.param1 ? params.param1 : '', 
                param2: params.param2 ? params.param2 : '', 
                param3: params.param3 ? params.param3 : '',
                proteus_chat_id: params.chatId ? params.chatId : 0,
                domain: params.domain ? params.domain : '',
                is_guest: params.guest,
            }, 
            mode: 'widget',
            fscreen: true,
            lhc_base_url: 'https://' + LIVECHAT_BASE_URL + '/index.php/',
            survey: 2,
            check_messages: false, 
            theme: 1
        };

        this.initialize();
    }

    initialize() {
        
        var LHC_API = LHC_API || {};
        if (typeof lhc_var === 'undefined') {
            window.lhc_var = {};
        }

        LHC_API.args = this.args;

        window.lhc_var = this.args.lhc_var;
        window.LHC_API = LHC_API;

        const po = document.createElement('script');
        po.type = 'text/javascript';
        po.setAttribute('crossorigin', 'anonymous');
        po.async = true;

        const date = new Date();
        po.src = `https://${LIVECHAT_BASE_URL}/design/defaulttheme/js/widgetv2/index.js?${date.getFullYear()}${date.getMonth()}${date.getDate()}`;
        
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(po, s);

        // Listeners
        window.addEventListener("message", (event) => {
            if (!event.data || !event.data.name) return;
            switch (event.data.name) {
                
                case 'endLiveChat':
                    this.signalEndChat();
                    break;
                default:
                    break;
            }
        
            return;
        });
    }

    async startEscalatedChat(window) {
        if (!window || !window.$_LHC || !this.args.lhc_var) {
            console.error('Unable to start chat: livechat widget is missing.');
            return;
        }

        // Send user parameters to LHC
        for (const attr in this.args.lhc_var) {
            const value = this.args.lhc_var[attr];
            if (!this.shouldIncludeAttribute(attr, value)) continue;

            window.$_LHC.eventListener.emitEvent('sendChildEvent', [{
                'cmd': 'attr_set', 
                'arg': {
                    'type': 'attr_set', 
                    'attr': [attr], 
                    'data': value,
                }
            }]);
        }

        // Trigger autosubmission
        window.$_LHC.eventListener.emitEvent('proteusAutoSubmit');

        // Set no-scroll class on proteus widget
        const appElement = document.querySelector('#app');
        if (appElement && !appElement.classList.contains('embedded-livechat-widget')) {
            appElement.classList.add('embedded-livechat-widget');
        }
    }

    setAttribute(attr, value) {
        if (Object.prototype.hasOwnProperty.call(this.args.lhc_var, attr)) {
            this.args.lhc_var[attr] = value;
        }
    }

    shouldIncludeAttribute(key, keyValue) {
        let includeParameter = false;
        
        switch (key) {
            case 'proteus_chat_id':
                if (keyValue !== 0) includeParameter = true;
                break;
            default:
                if (keyValue !== "") includeParameter = true;
        }

        return includeParameter;
    }

    async open() {
        try {
            this.startEscalatedChat(window);
        } catch (e) {
            console.error("error opening livechat: ", e);
            throw e;
        }
    }

    async signalEndChat() {
        window.$_LHC.eventListener.emitEvent('proteusSignalEndChat');
    }
}

export default LiveChat;
